var App = function () {
  this.sections = {};
  this.nav      = new Navigator('.nav');
  this.ctrl     = new ScrollMagic.Controller();
};

var controller = new ScrollMagic.Controller({});
var app;

$(document).ready(function () {
  $('body').removeClass('no-js');

  var carousel = $('.slick-carousel.center');
  var bLazy = new Blazy({
    offset: 500,
    breakpoints: [{
      width: 640,
      src: 'data-src-small'
    },
    {
      width: 768,
      src: 'data-src-medium'
    },
    {
      width: 1200,
      src: 'data-src-normal'
    }]
  });

  carousel.on('afterChange', function(event, slick, direction){
    bLazy.revalidate();
  });

  carousel.slick({
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    draggable: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    responsive: [
    {
      breakpoint: 680,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
    ]
  });

  app = new App();

  // Add smooth scrolling to all links
  $("a.cta-scroll-to").on('click', function (event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function () {

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
  cover();
  animateSections();
  animateSubSections();
  animateBlocks();
  animateProjects();
  animateInnovators();
  animateLogos();
  initMap();

  // Navigation.
  var $sections = $('.section');
  $sections.each(function () {
    var $this   = $(this);
    var section = $this.data('section');
    var title   = $this.data('title');
    var chapter = $this.data('chapter');
    app.nav.addItem(section, title, chapter);
  });

  $('.open-nav').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    if ($(this).hasClass('active')) {
      app.nav.closeMenu();
    }
    else {
      app.nav.openMenu();
    }
  });


  $('.nav-list .nav-item a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    app.nav.navigate(this);
  });

});
